<template>
  <v-layout row wrap>
      <v-flex xs12 lg6 offset-lg3>
        <v-expansion-panel popout dark class="mb-2">
          <v-expansion-panel-content lazy class="blue-grey">
            <div slot="header"><strong>Job Details</strong></div>
            <v-card>
              <v-list class="blue-grey">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>Customer: {{ customerName }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>Vehicle: {{ currentJob.vehicle ? vehicleRegFromID(currentJob.vehicle) : currentJob.reg }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="currentJob.requirements">
                  <v-list-tile-content>
                    <v-list-tile-title>Requirements: {{ currentJob.requirements }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="currentJob.network">
                  <v-list-tile-content>
                    <v-list-tile-title>Network: {{ currentJob.network }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="currentJob.APN">
                  <v-list-tile-content>
                    <v-list-tile-title>APN: {{ currentJob.APN }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="currentJob.newReg">
                  <v-list-tile-content>
                    <v-list-tile-title>New Reg: {{ currentJob.newReg }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="currentJob.newMake">
                  <v-list-tile-content>
                    <v-list-tile-title>New Make: {{ currentJob.newMake }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="currentJob.newModel">
                  <v-list-tile-content>
                    <v-list-tile-title>New Model: {{ currentJob.newModel }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="currentJob.leaveKit">
                  <v-list-tile-content>
                    <v-list-tile-title>Where to leave kit: {{ currentJob.leaveKit }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="currentJob.getKit">
                  <v-list-tile-content>
                    <v-list-tile-title>Where to get kit: {{ currentJob.getKit }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel popout dark>
          <v-expansion-panel-content lazy v-for="(item,i) in templates" :key="i" :class="checkListComplete(i)">
            <div slot="header"><strong>{{item.name}}</strong></div>
            <v-card>
              <v-list three-line>
                <v-list-group lazy v-for="(subitem, index) in templates[i].items" v-bind:key="index" avatar :value="true">
                  <v-list-tile v-if="subitem.text !== undefined && subitem.text.indexOf('c.isni.co') !== -1 && !subitem.test">
                    <a @click.prevent="gotoIsniTestPage" class="cyan--text"> Visit Test Site<v-icon>open_in_new</v-icon></a>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-avatar>
                      <v-icon icon v-bind:color="(subitem.image && subitem.image.length > 0) || (subitem.note && subitem.note.length > 0) > 0 ? 'green' : 'grey'" v-html="listIcon(subitem)"></v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="mb-2">{{ subitem.title }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ subitem.text }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="!subitem.optional === true">
                      <v-icon color="grey lighten-1">visibility</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-list-tile>
                      <template v-if="subitem.photo && !subitem.test">
                        <img v-if="subitem.image" :src="imageObj[subitem.image]" @click="openFullImage(imageObj[subitem.image], i, index)"  height="80"/>
                        <v-btn v-else :loading="imageProcessing" @click="triggerPick(i, index, 'photo')" color="primary"><v-icon>add_a_photo</v-icon>{{subitem.image ? ' Change Photo' : ' Add Photo'}}</v-btn>
                      </template>
                      <template v-if="!subitem.test">
                        <p v-if="subitem.note"  @click="triggerPick(i, index, 'note')" style="overflow: hidden; display: -webkit-box; box-orient:vertical; line-clamp: 3; height: 80px; width:100%;" class="pa-1 mb-0 ml-1 white black--text">{{subitem.note}}</p>
                        <v-btn v-else @click="triggerPick(i, index, 'note')" color="primary" :disabled="subitem.photo && subitem.image.length < 1"><v-icon>note_add</v-icon>{{subitem.note ? ' Change Note' : ' Add Note'}}</v-btn>
                      </template>
                      <v-btn v-if="subitem.test" @click="gotoTestPage(i, index)" color="primary"><v-icon>mdi-cloud-check</v-icon> Run Test</v-btn>
                  </v-list-tile>
                </v-list-group>
                <v-list-group lazy v-if="item.name === 'Lisle RDL'" avatar :value="true">
                  <v-list-tile>
                    <v-btn @click.prevent="rdlTest()" color="primary" block>Test RDL</v-btn>
                  </v-list-tile>
                </v-list-group>
                <v-list-group lazy v-if="item.name === 'Digi-DL'" avatar :value="true">
                  <v-list-tile>
                    <v-btn @click.prevent="dlTest()" color="primary" block>Test DL</v-btn>
                  </v-list-tile>
                </v-list-group>
              </v-list>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-textarea v-model="currentJob.notes" label="General Notes" @change="saveJob" class="mx-2"/>
        <v-checkbox v-model="currentJob.chargeable" label="Is this job chargeable?" @change="saveJob" class="mx-2"/>
        <v-btn block color="primary" @click="saveForLater">Save for Later</v-btn>
        <v-btn :disabled="readyToSend" block color="primary" @click="completeJob">Save and Send</v-btn>
        <v-btn @click="downloadJob" block color="primary"><v-icon left dark>archive</v-icon> Download Zip File</v-btn>
        <!-- <v-btn @click="createFileStore" :disabled="!!imageDirectoryHandle">SETUP file store</v-btn> -->
        <input id="imagePicker" type="file" accept="image/jpeg" @change="saveImages" style="display:none;">
        <canvas hidden id="imageCanvas"></canvas>
        <v-layout row justify-center>
          <v-dialog v-model="enterNote" fullscreen transition="dialog-bottom-transition" :overlay="false">
           <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon @click.native="enterNote = false" dark>
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Note</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn dark flat @click.native="saveNote">Save Note</v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-flex xs10 offset-xs1>
                <v-textarea
                  label="Add notes here"
                  v-model="currentNote"
                ></v-textarea>
              </v-flex>
            </v-card>
          </v-dialog>
        </v-layout>
        <v-layout row justify-center>
          <v-dialog v-model="fullImage" fullscreen transition="dialog-bottom-transition" :overlay="false">
           <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon @click.native="fullImage = false" dark>
                  <v-icon>close</v-icon>
                </v-btn>
                <v-spacer />
                <v-btn @click="changeImage" flat>Change Image</v-btn>
              </v-toolbar>
              <v-flex xs12>
                <img :src="fullImageSrc" style="width:100%;"/>
              </v-flex>
            </v-card>
          </v-dialog>
        </v-layout>
        <v-dialog v-model="testingDialog" fullscreen>
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="testingDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Testing</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark flat @click="testingDialog = false">Save Test</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <testing :testType="testType" :testID="testID" @testId="saveTest" />
          </v-card>
        </v-dialog>
        <v-dialog v-model="rdlTestDialog" fullscreen>
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>RDL Testing</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="rdlTestDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <iframe id="rdlFrame" style="width:100%; height:100vh;" src="https://m.digidown.net/rdl_status/"></iframe>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dlTestDialog" fullscreen>
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>DL Testing</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="dlTestDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <iframe id="dlFrame" style="width:100%; height:100vh;" src="https://cwelite.aquariusit.com/dl-status/"></iframe>
          </v-card>
        </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import dbPromise from '../dbPromise'
import moment from 'moment'
import saveAs from 'file-saver'
import JsZip from 'jszip'
import { fireStore, storage } from '../firebase'

export default {
  data () {
    return {
      templates: [{
        items: {
          1: {
            optional: false,
            image: '',
            note: '',
            photo: false
          }
        }
      }],
      fullImage: false,
      fullImageSrc: '',
      fullImageTemplate: null,
      fullImageChild: null,
      testingDialog: false,
      currentItem: '',
      currentNote: '',
      customerName: '',
      enterNote: false,
      imageProcessing: false,
      currentJob: {
        Customer: '',
        Vehicle: '',
        notes: '',
        chargeable: false
      },
      imageObj: {},
      testID: '',
      testType: 'IMEI',
      imageDirectoryHandle: null,
      quickSend: false,
      rdlTestDialog: false,
      dlTestDialog: false
    }
  },
  mounted () {
    dbPromise().then((db) => {
      let tx = db.transaction('currentJob')
      let currentStore = tx.objectStore('currentJob')
      return (currentStore.getAll())
    }).then((val) => {
      if (val.length > 0) {
        this.currentJob = val[0]
        this.templates = val[1]
        console.log(this.templates)
        if (this.templates.findIndex(template => { return ['Calamp Trailer', 'Calamp Trailer No EBS Cable', 'Trailer Smart Novacom', 'Temperature', 'Trailer Service Call'].indexOf(template.name) !== -1 }) > -1) {
          const index = this.templates.findIndex(template => {
            return template.name === 'Vehicle Pre-Install Check'
          })
          if (index > -1) {
            this.templates.splice(index, 1)
          }
          const pIndex = this.templates.findIndex(template => {
            return template.name === 'Post Install Check & Testing'
          })
          if (pIndex > -1) {
            this.templates.splice(pIndex, 1)
          }
        }
        fireStore.collection('Customers').doc(this.currentJob.Customer).get()
        .then(doc => {
          this.customerName = doc.data().customerName
        })

        for (let template of this.templates) {
          for (let item of template.items) {
            if (item.image) {
              dbPromise().then(function (db) {
                let tx = db.transaction('imageStore')
                let imageStore = tx.objectStore('imageStore')
                return (imageStore.get(item.image))
              })
              .then(async (image) => {
                this.imageObj[item.image] = image.image
              })
            }
          }
        }
      }
    })

    // dbPromise().then((db) => {
    //   let tx = db.transaction('fileDirLocation')
    //   let fileDirLocation = tx.objectStore('fileDirLocation')
    //   return (fileDirLocation.getAll())
    // }).then((val) => {
    //   if (val.length > 0) {
    //     this.imageDirectoryHandle = val[0]
    //   }
    // })
  },
  computed: {
    readyToSend () {
      for (let template in this.templates) {
        for (let item in this.templates[template].items) {
          if (this.templates[template].items[item].optional === false && this.templates[template].items[item].image === '' && this.templates[template].items[item].note === '') {
            return true
          }
        }
      }
      return false
    },
    vehicles () {
      return this.$store.getters.vehicles
    },
    currentJobVehicle () {
      const index = this.vehicles.findIndex(vehicle => {
        return this.currentJob.vehicle === vehicle.id
      })
      if (index > -1) {
        return this.vehicles[index]['VehicleReg']
      } else {
        return null
      }
    }
  },
  methods: {
    rdlTest () {
      setTimeout(() => {
        document.getElementById('rdlFrame').src = document.getElementById('rdlFrame').src
      }, 200)
      this.rdlTestDialog = true
    },
    dlTest () {
      setTimeout(() => {
        document.getElementById('dlFrame').src = document.getElementById('dlFrame').src
      }, 200)
      this.dlTestDialog = true
    },
    changeImage () {
      this.triggerPick(this.fullImageTemplate, this.fullImageChild, 'photo')
      this.fullImage = false
    },
    openFullImage (imageSrc, template, child) {
      this.fullImageSrc = imageSrc
      this.fullImageTemplate = template
      this.fullImageChild = child
      this.fullImage = true
    },
    async createFileStore () {
      const dirHandle = await window.showDirectoryPicker()
      this.imageDirectoryHandle = await dirHandle.getDirectoryHandle('Engineer Images', {
        create: true
      })
      dbPromise().then((db) => {
        let tx = db.transaction('fileDirLocation', 'readwrite')
        let fileDirLocation = tx.objectStore('fileDirLocation')

        fileDirLocation.put(this.imageDirectoryHandle, 1)
        return tx.complete
      })
      .then(() => {
        console.log('saved')
      })
    },
    gotoIsniTestPage () {
      window.open('http://c.isni.co')
    },
    saveTest (value) {
      this.templates[this.currentItem[0]]['items'][this.currentItem[1]]['note'] = value
      dbPromise().then((db) => {
        let tx = db.transaction('currentJob', 'readwrite')
        let currentStore = tx.objectStore('currentJob')

        currentStore.put(this.templates, 1)
        return tx.complete
      })
    },
    gotoTestPage (template, child) {
      this.currentItem = [template, child]
      if (this.currentJob.jobLookupIds) {
        let testingDetails = this.currentJob.jobLookupIds.find(id => id.IMEI || id.DVR)
        if (testingDetails) {
          this.testType = testingDetails.IMEI ? 'IMEI' : 'DVR'
          this.testID = testingDetails[this.testType]
        } else if (this.currentJob.imei) {
          this.testType = 'IMEI'
          this.testID = this.currentJob.imei
        }
      }
      this.testingDialog = true
    },
    saveNote () {
      this.templates[this.currentItem[0]]['items'][this.currentItem[1]]['note'] = this.currentNote
      dbPromise().then((db) => {
        let tx = db.transaction('currentJob', 'readwrite')
        let currentStore = tx.objectStore('currentJob')

        currentStore.put(this.templates, 1)
        return tx.complete
      })
      .then(() => {
        this.enterNote = false
      })
    },
    saveJob () {
      console.log('save Jonb')
      dbPromise().then((db) => {
        let tx = db.transaction('currentJob', 'readwrite')
        let currentStore = tx.objectStore('currentJob')

        currentStore.put(this.currentJob, 0)
        return tx.complete
      })
    },
    checkListComplete (i) {
      for (let item in this.templates[i].items) {
        if (this.templates[i].items[item].optional === false && this.templates[i].items[item].image === '' && this.templates[i].items[item].note === '') {
          return 'mb-1'
        }
      }
      return 'green mb-1'
    },
    listIcon (item) {
      if (!item.test && item.photo === true) {
        return item.image.length > 0 ? 'check' : 'add_a_photo'
      } else {
        return item.note.length > 0 ? 'check' : 'note_add'
      }
    },
    triggerPick (template, child, type) {
      if (!this.imageProcessing) {
        this.currentItem = [template, child]
        if (type === 'photo') {
          document.getElementById('imagePicker').click()
          this.currentNote = ''
        } else {
          this.enterNote = true
          this.currentNote = this.templates[this.currentItem[0]]['items'][this.currentItem[1]]['note']
        }
      }
    },
    saveForLater () {
      dbPromise().then(db => {
        let tx = db.transaction('inProgressJobs', 'readwrite')
        let inProgressStore = tx.objectStore('inProgressJobs')
        let arr = []
        arr[0] = this.currentJob
        arr[1] = this.templates
        if (this.currentJob.inProgressKey) {
          inProgressStore.put(arr, this.currentJob.inProgressKey)
        } else {
          inProgressStore.put(arr)
        }
        return tx.complete
      })
      .then(() => {
        dbPromise().then((db) => {
          let tx = db.transaction('currentJob', 'readwrite')
          let currentStore = tx.objectStore('currentJob')

          currentStore.clear()
          return tx.complete
        })
        .then(() => {
          this.$router.push('/JobList')
        })
      })
    },
    completeJob () {
      fireStore.collection('Jobs').doc(this.currentJob.number).update({jobEnded: moment().format('x')})
      this.currentJob.CompletedDate = moment().format('YYYY-MM-DD')
      this.currentJob.endTime = moment().format('x')
      dbPromise().then((db) => {
        let tx = db.transaction('outbox', 'readwrite')
        let outboxStore = tx.objectStore('outbox')
        let completedJob = this.currentJob
        completedJob.template = this.templates
        outboxStore.put(completedJob)
        return tx.complete
      })
      .then(() => {
        dbPromise().then((db) => {
          let tx = db.transaction('currentJob', 'readwrite')
          let currentStore = tx.objectStore('currentJob')

          currentStore.clear()
          if (this.currentJob.inProgressKey) {
            tx = db.transaction('inProgressJobs', 'readwrite')
            let inProgressStore = tx.objectStore('inProgressJobs')
            inProgressStore.delete(this.currentJob.inProgressKey)
          }

          return tx.complete
        })
        .then(() => {
          this.$router.push('/')
        })
      })
    },
    vehicleRegFromID (id) {
      const index = this.vehicles.findIndex(vehicle => {
        return vehicle.id === id
      })
      if (index > -1) {
        return this.vehicles[index]['VehicleReg']
      } else {
        return ''
      }
    },
    saveImages (e) {
      this.imageProcessing = true
      let file = e.target.files[0]
      let filename = Date.now() + '.jpg'
      let reader = new FileReader()
      if (file) {
        reader.readAsArrayBuffer(file)
        reader.onload = (event) => {
          let exif = this.getExifData(event.target.result)
          let c = document.getElementById('imageCanvas')
          let ctx = c.getContext('2d')
          let img = new Image()
          if (img.style.imageOrientation !== undefined) {
            exif = 1
          }
          img.src = URL.createObjectURL(e.target.files[0])
          img.onload = () => {
            if (exif > 4) {
              c.width = img.height / 2
              c.height = img.width / 2
              ctx.scale(0.5, 0.5)
              ctx.clearRect(0, 0, c.width, c.height)
              ctx.translate(img.height / 2, img.width / 2)
              if (exif > 6) {
                ctx.rotate(270 * Math.PI / 180)
              } else {
                ctx.rotate(90 * Math.PI / 180)
              }
              ctx.drawImage(img, -img.width / 2, -img.height / 2)
            } else {
              c.width = img.width / 2
              c.height = img.height / 2
              ctx.scale(0.5, 0.5)
              if (exif === 3 || exif === 4) {
                ctx.clearRect(0, 0, c.width, c.height)
                ctx.translate(img.width, img.height)
                ctx.rotate(180 * Math.PI / 180)
              }
              ctx.drawImage(img, 0, 0)
            }
            let cameraQuality = localStorage.getItem('cameraQuality') !== null && localStorage.getItem('cameraQuality') !== undefined ? localStorage.cameraQuality : 30
            cameraQuality = cameraQuality / 100
            let base64data = c.toDataURL('image/jpeg', cameraQuality)
            this.imageObj[filename] = base64data

            this.$forceUpdate()

            dbPromise().then(function (db) {
              let tx = db.transaction('imageStore', 'readwrite')
              let imageStore = tx.objectStore('imageStore')

              imageStore.put({image: base64data, name: filename, type: file.type}, filename)
              return tx.complete
            })
            .then(async () => {
              this.snackbar = true
              this.templates[this.currentItem[0]]['items'][this.currentItem[1]]['image'] = filename
              if (this.quickSend) {
                let image = base64data
                let imageName = filename
                try {
                  let imageObj = await this.uploadImage(this.currentJob, imageName)
                  this.templates[this.currentItem[0]]['items'][this.currentItem[1]]['image'] = imageObj.ref
                  this.templates[this.currentItem[0]]['items'][this.currentItem[1]]['imageName'] = imageObj.name
                  this.deleteImageFromDB(image)
                } catch (error) {
                  console.log(error)
                }
              }
              dbPromise().then((db) => {
                let tx = db.transaction('currentJob', 'readwrite')
                let currentStore = tx.objectStore('currentJob')

                currentStore.put(this.templates, 1)
                return tx.complete
              })
              .then(() => {
                this.snackbarText = 'Image saved locally'
                document.getElementById('imagePicker').value = ''
                this.imageProcessing = false
              })
            })
            .catch(e => {
              console.log(e)
              this.imageProcessing = false
            })
          }
        }
      }
    },
    deleteImageFromDB (key) {
      return dbPromise().then(function (db) {
        let tx = db.transaction('imageStore', 'readwrite')
        let imageStore = tx.objectStore('imageStore')
        imageStore.delete(key)
        return true
      })
      .catch(() => {
        return false
      })
    },
    uploadImage (job, image) {
      console.log(image)
      return dbPromise().then(function (db) {
        let tx = db.transaction('imageStore')
        let imageStore = tx.objectStore('imageStore')
        return (imageStore.get(image))
      })
      .then(async (image) => {
        if (image) {
          let bytes = image.image
          let ref = storage.ref(job.JobNo + '/' + image.name)
          let response = await ref.putString(bytes, 'data_url', {cacheControl: 'only-if-cached'})
          return {ref: response, name: image.name}
        }
      })
      .then((snapshotObj) => {
        return {ref: snapshotObj.ref.downloadURL, name: snapshotObj.name}
      })
    },
    async saveToDisk (data) {
      console.log(this.imageDirectoryHandle)
      let hasPermission = false
      // Check if permission was already granted. If so, return true.
      if ((await this.imageDirectoryHandle.queryPermission({mode: 'readwrite'})) === 'granted') {
        hasPermission = true
      }
      // Request permission. If the user grants permission, return true.
      if ((await this.imageDirectoryHandle.requestPermission({mode: 'readwrite'})) === 'granted') {
        hasPermission = true
      }
      if (hasPermission) {
        let handle = await this.imageDirectoryHandle.getFileHandle('test.jpeg', { create: true })
        this.writeURLToFile(handle, data)
      }
    },
    async getNewFileHandle () {
      const options = {
        types: [
          {
            description: 'Images',
            accept: {
              'image/jpeg': ['.jpeg']
            }
          }
        ]
      }
      const handle = await window.showSaveFilePicker(options)
      return handle
    },
    async writeURLToFile (fileHandle, url) {
      // Create a FileSystemWritableFileStream to write to.
      const writable = await fileHandle.createWritable()
      // Make an HTTP request for the contents.
      const response = await fetch(url)
      // Stream the response into the file.
      await response.body.pipeTo(writable)
      // pipeTo() closes the destination pipe by default, no need to close it.
    },
    downloadJob (jobNumber) {
      this.logDialogTitle = 'Download Job'
      this.logDialogInfo = 'Download starting'
      this.logDialogLog = ''
      this.logDialog = true
      this.generateZip(jobNumber, (content, zipName) => {
        this.logDialogLog += 'Zip file generated, downloading now\n'
        saveAs(content, zipName + '.zip')
        this.logDialogInfo = 'Download complete'
        this.logDialogLog += 'Download complete\n'
      })
    },
    generateZip (jobNumber, zipCallback) {
      const zip = new JsZip()

      let job = this.currentJob
      job.template = this.templates
      zip.file('Job Data.txt', JSON.stringify(job))
      this.logDialogLog += 'Job data added to zip\n'
      let promises = []
      for (let template in this.templates) {
        this.templates[template].items.map((obj, item) => {
          promises.push(new Promise((resolve, reject) => {
            const thisItem = this.templates[template].items[item]
            const title = thisItem.title
            if (thisItem.image !== '') {
              dbPromise().then(db => {
                let tx = db.transaction('imageStore')
                let imageStore = tx.objectStore('imageStore')
                return (imageStore.get(thisItem.image))
              })
              .then((image) => {
                if (image !== undefined) {
                  // Prepare image for sending
                  let bytes = image.image
                  zip.file(template + '-' + title + '.jpg', bytes.replace('data:image/jpeg;base64,', ''), { base64: true })
                  this.logDialogLog += title + ' image added to zip file\n'
                  resolve('image')
                }
              })
            } else if (thisItem.note) {
              this.logDialogLog += template + '-' + title + ' is a note, adding as text file\n'
              zip.file(template + '-' + title + '.txt', thisItem.note)
              resolve('note')
            } else {
              this.logDialogLog += template + '-' + title + ' is not a note or an image, may be an optional item which was skipped\n'
              resolve('no image')
            }
          }))
        })
      }
      Promise.all(promises)
      .then(value => {
        zip.generateAsync({type: 'blob'})
        .then(function (content) {
          let zipName = ''
          if (job.JobNo) {
            zipName = job.JobNo
          } else if (job.reg) {
            zipName = job.reg
          } else {
            zipName = moment().format('X')
          }
          zipCallback(content, zipName)
          // saveAs(content, zipName + '.zip')
        })
      })
    },
    getExifData (image) {
      let view = new DataView(image)
      if (view.getUint16(0, false) !== 0xFFD8) return -2
      let length = view.byteLength
      let offset = 2
      while (offset < length) {
        let marker = view.getUint16(offset, false)
        offset += 2
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) return -1
          let little = view.getUint16(offset += 6, false) === 0x4949
          offset += view.getUint32(offset + 4, little)
          let tags = view.getUint16(offset, little)
          offset += 2
          for (let i = 0; i < tags; i++) {
            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
              return view.getUint16(offset + (i * 12) + 8, little)
            }
          }
        } else if ((marker & 0xFF00) !== 0xFF00) {
          break
        } else {
          offset += view.getUint16(offset, false)
        }
      }
      return -1
    }
  }
}
</script>

<style>
  .v-list__group__header{
    display:none;
  }
</style>



// WEBPACK FOOTER //
// CurrentJob.vue?f5f09968